import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;
export interface IAcceptEventPrices {
	companyName: string;
	eventID: number;
}
export const { thunk: acceptEventPrices, slice: acceptEventPricesSlice } = getThunkAndSlice<
	IAcceptEventPrices,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/AcceptEventPrices",
	method: "post",
});
